<template>
<div class="moreSeparator clearfix">
  <div class="moreSeparatorBox" @click="moreClick">
    <span :class="klass"></span><span class="moreLable">{{label}}</span>
  </div>
</div>
</template>

<script>

import eBase from '@/base/eBase.js';
import _ from 'underscore';
import { defaultCoreCipherList } from 'constants';

export default {

  props: {
    mode: { require: true }
  },

  data() {
    return {
      label: "更多详细信息",
      klass:"menu-mini-icon mini-icon-1-2 separator_icon",
    };
  },

  mounted() {
    this.init();
  },

  watch: {
    mode: {
      handler(newValue, oldValue) {
        if(newValue) {
          this.klass = "menu-mini-icon mini-icon-1-2 separator_icon";
          this.label = "更多详细信息"
        } else {
          this.klass = "menu-mini-icon mini-icon-2-2 separator_icon";
          this.label = "收起详细信息"
        }
      },
      immediated: false,
    },
  },

  computed: {
  },

  methods: {

    init() {
    },

    moreClick() {
      this.$emit("moreClick");
    },

  }, // EOF methods
};
</script>



// WEBPACK FOOTER //
// src/components/select/MoreSeparator.vue